import { render, staticRenderFns } from "./ActiveBadge.vue?vue&type=template&id=5b6a6ff8&scoped=true"
import script from "./ActiveBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActiveBadge.vue?vue&type=style&index=0&id=5b6a6ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a6ff8",
  null
  
)

export default component.exports